import { c as _c } from "react/compiler-runtime";
import { ExportDropdown } from "@components/common/export/export-dropdown";
import { useDateTime } from "@hooks/use-date-time";
import { defaultProjectLaunchTargetSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { downloadSnapshotsData } from "@utils/file-data-export";
import { TableType } from "@utils/track-event/track-event-list";
import { useCallback } from "react";
/** Dropdown to export snapshots in the file format selected by the user */
export function BulkExportSnapshots(t0) {
  const $ = _c(13);
  const {
    selectedSnapshots,
    projectName,
    areEntitiesSelected,
    buttonType
  } = t0;
  const {
    formatDate
  } = useDateTime();
  const {
    defaultOpenProjectTarget
  } = useAppSelector(defaultProjectLaunchTargetSelector);
  let t1;
  if ($[0] !== defaultOpenProjectTarget || $[1] !== formatDate || $[2] !== projectName || $[3] !== selectedSnapshots) {
    t1 = async format => await downloadSnapshotsData({
      snapshots: selectedSnapshots,
      fileName: `${projectName} - Snapshots List`,
      formatDate,
      format,
      defaultOpenProjectTarget
    });
    $[0] = defaultOpenProjectTarget;
    $[1] = formatDate;
    $[2] = projectName;
    $[3] = selectedSnapshots;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const exportHandler = t1;
  let t2;
  if ($[5] !== areEntitiesSelected || $[6] !== selectedSnapshots.length) {
    t2 = {
      dataType: TableType.snapshots,
      numberOfEntities: selectedSnapshots.length,
      areEntitiesSelected
    };
    $[5] = areEntitiesSelected;
    $[6] = selectedSnapshots.length;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      success: "Successfully exported snapshots.",
      error: "Cannot export snapshots. Please try again."
    };
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== buttonType || $[10] !== exportHandler || $[11] !== t2) {
    t4 = <ExportDropdown trackingProps={t2} exportHandler={exportHandler} toastMessage={t3} buttonTooltipText="Export snapshots" buttonType={buttonType} />;
    $[9] = buttonType;
    $[10] = exportHandler;
    $[11] = t2;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}